import React from 'react';
import {
    connect
} from 'react-redux';
import {
    actionCreators
} from './store';
import { WhiteSpace } from 'antd-mobile';
import './index.css'
import Header from 'component/mobile_header'
import InfoBottom from './components/infoBottom'
import InfoImg from './components/infoImg'
import InfoDes from './components/infoDes'
import InfoTab from './components/infoTab'
class Courseinfo extends React.Component {
    constructor(props){
        super(props);
        this.state={
            title:'课程详情'
        }
    }
  componentWillMount() {
    const { getCourseWatched,getCourseInfo, infoList ,user_id,changeCourseInfo,getRecord} = this.props;
       getCourseWatched(this.props.match.params.id)
    getCourseInfo(this.props.match.params.id)
       //获取是否收藏
    getRecord(this.props.match.params.id,user_id)
  }

  recordClick(){
    const {addRecord,delRecord,collect,user_id} =this.props
      if(!collect){
        addRecord(this.props.match.params.id,user_id)
      }else{
        delRecord(this.props.match.params.id,user_id)
      }
  }
  render() {
    const {info,sid,collect} =this.props;
      return (
        <div>
          <Header title = {this.state.title}/>
          <div className="container info" >
            <InfoImg thumb={info.get('thumb')}/>
            <InfoDes data={info}/>
            <InfoTab/>
          </div>
           <InfoBottom
            collect={collect}
            id={this.props.match.params.id}
            recordClick={()=>{this.recordClick()}}
            sid={sid}
             />
            }
        </div>
      )
  }
}


const mapState = (state) => ({
    infoList: state.getIn(['courseexper', 'infoList']),
    info: state.getIn(['courseexper', 'info']),
    sid: state.getIn(['courseexper', 'sid']),
    collect:state.getIn(['courseexper', 'collect']),
    user_id: state.getIn(['home','userinfo', 'user_id']),
})

const mapDispatch = (dispatch) => ({
    getCourseInfo(course_id) {
      dispatch(actionCreators.getCourseInfo(course_id))
    },
    changeCourseInfo(info,sid){
      dispatch(actionCreators.changeCourseInfo(info,sid))
    },
    getRecord(course_id,user_id){
      dispatch(actionCreators.getRecord(course_id,user_id))
    },
    addRecord(course_id,user_id){
      dispatch(actionCreators.addRecord(course_id,user_id))
    },
    delRecord(course_id,user_id){
      dispatch(actionCreators.delRecord(course_id,user_id))
    },
    getCourseWatched(course_id){
        dispatch(actionCreators.getCourseWatched(course_id))
    }
})
export default connect(mapState, mapDispatch)(Courseinfo);
